import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_1: FaireProductEntity = {
  token: "starter_collection_1",
  type: "product",
  name: "'\"Drizzle\" Glass'",
  brandName: "Graza",
  imageUrl: "",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
